import { RequestError, RequestOptions } from '../types';

interface Params {
  url: string;
  method: string;
  data: any;
  params: any;
  dataType: string;
  headers?: {
    [key: string]: any;
  };
}
const request = (method: 'POST' | 'GET') => <T>(opions: RequestOptions): Promise<[null, T] | [RequestError]> => {
  const Network = Mach.requireModule('Network');
  return new Promise((resolve) => {
    const { url, data = null } = opions;
    const params: Params = {
      url,
      method,
      data: null,
      params: null,
      dataType: 'json',
      // headers: {
      //  swimlane: 'panzongming-abomf',
      // },
    };
    if (method === 'GET') {
      params.params = data;
    } else {
      params.data = data;
    }
    Network.request(params, (result) => {
      const { data, error } = result;
      if (!error) {
        const { message = '', data: rawData, code } = data || {};
        if (code === 0) {
          resolve([null, rawData]);
        } else {
          resolve([{ message, code }]);
        }
        return;
      }
      resolve([{ message: 'request fail', code: -1 }]);
    });
  });
};

const $post = request('POST');
const $get = request('GET');
export { $post, $get };
